import React from "react";
import { Container } from "react-bootstrap";
// import { Alert } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import Notifications from "../push-notifications/Notifications";
import DFStructure from "./DFStructure";
import WelcomeUser from "../Open-pages/user/WelcomeUser";

const DFPayments = ({
  userInfoData,
  isCustom,
  isIOS,
  // isNotificationDenied,
}) => {
  return (
    <HelmetWrapper title="WTF: Deffered Payments">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        {isCustom && (
          <div className="mt30">
            <WelcomeUser userName={userInfoData?.name} />

            {userInfoData && !isIOS() && (
              <Notifications authData={userInfoData} />
            )}

            {/* {isNotificationDenied === "denied" && (
              <Alert variant={"danger"} className="mt30">
                Notification permission is denied. Unable to display desktop
                notifications.
              </Alert>
            )} */}
          </div>
        )}

        <DFStructure userInfoData={userInfoData} isCustom={isCustom} />
      </Container>
    </HelmetWrapper>
  );
};

export default DFPayments;
